import { ColumnDefinition } from './interfaces/ColumnDefinition';
import { BorrowerLendingLimitTableType } from './BorrowerLendingLimitTableType';
import { GuarantorSummaryColumns } from './columns/GuarantorSummaryColumns';
import { CoreColumns } from './columns/CoreColumns';
import { BridgeColumns } from './columns/BridgeColumns';
import { SBAColumns } from './columns/SBAColumns';
import { RentalColumns } from './columns/RentalColumns';
import { GuarantorSummaryRows } from './rows/GuarantorSummaryRows';

export const BorrowerLendingLimitTableDefinition: Record<BorrowerLendingLimitTableType, ColumnDefinition<string>[]> = {
    [BorrowerLendingLimitTableType.GuarantorSummary]: [
        {
            field: GuarantorSummaryColumns.SummaryItemType,
            infoBubble: {
                [GuarantorSummaryRows.Construction]: 'Includes Construction, Fix Flip, Land, & Model Loans',
                [GuarantorSummaryRows.DSCR]: 'Includes Rental & Build-Rent Loans',
            },
        },
        { field: GuarantorSummaryColumns.BLL, calculationLogic: 'Current Borrower BLL' },
        { field: GuarantorSummaryColumns.OutstandingAmount, calculationLogic: 'Total Outstanding Commitments' },
        { field: GuarantorSummaryColumns.Surplus, calculationLogic: 'Total Commitments Over BLL' },
        { field: GuarantorSummaryColumns.RegBLLCapacity, calculationLogic: 'Available BLL Capacity' },
        { field: GuarantorSummaryColumns.MaxSurplus, calculationLogic: '' },
        { field: GuarantorSummaryColumns.Total, calculationLogic: 'Total Available Capacity' },
    ],

    [BorrowerLendingLimitTableType.Core]: [
        { field: CoreColumns.SummaryItemType },
        { field: CoreColumns.OutstandingAmount, calculationLogic: 'Total outstanding core exposure' },
        { field: CoreColumns.OutstandingNumber },
        { field: CoreColumns.BfiRepaysAmount, calculationLogic: 'BFI repayment amount' },
        { field: CoreColumns.BfiRepaysNumber },
        { field: CoreColumns.ExternalNumber, calculationLogic: 'Externally verified projects' },
    ],

    [BorrowerLendingLimitTableType.Bridge]: [
        { field: BridgeColumns.OutstandingAmount, calculationLogic: '' },
        { field: BridgeColumns.OutstandingNumber },
        { field: BridgeColumns.BfiRepaysAmount, calculationLogic: '' },
        { field: BridgeColumns.BfiRepaysNumber },
    ],

    [BorrowerLendingLimitTableType.SBA]: [
        { field: SBAColumns.OutstandingAmount, calculationLogic: '' },
        { field: SBAColumns.OutstandingNumber },
        { field: SBAColumns.BfiRepaysAmount, calculationLogic: '' },
        { field: SBAColumns.BfiRepaysNumber },
    ],

    [BorrowerLendingLimitTableType.Rental]: [
        { field: RentalColumns.OutstandingAmount, calculationLogic: '' },
        { field: RentalColumns.OutstandingNumber },
        { field: RentalColumns.BfiRepaysAmount, calculationLogic: '' },
        { field: RentalColumns.BfiRepaysNumber },
    ],
};
